import { SubscriptionPage } from '@/pages/subscription';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/subscription')({
	component: SubscriptionPage,
});
